import { getFileNameFromSasUrl } from '@app/helper/fileHelper';
import API_PATHS from '../network/apiPaths';
import NetworkService from '../network/NetworkService';
import { getBase64UriFromBuffer } from '@app/helper/fileHelper';

export const fileAccessService = async ({
  sasUrl,
  contentType,
}: {
  sasUrl: string;
  contentType?: string;
}) => {
  console.log("In fileAccessService, sasUrl and contentType is ", sasUrl, contentType);

  try {
    const url = `${API_PATHS.DOCUMENT_DOWNLOAD}?sasUrl=${encodeURIComponent(sasUrl)}`;
    const response = await NetworkService.get(
      url,
      { sasUrl },
      null,
      false,
      'arraybuffer'
    );
    console.log("Response from file download API is ", response);
    contentType = contentType ? contentType : response.headers?.['content-type'] || 'application/octet-stream';
    const extractedFileName = getFileNameFromSasUrl(sasUrl);
    // Convert arraybuffer → base64 manually (no FileReader)
    const base64data = arrayBufferToBase64(response.data, contentType);
    console.log("base64data in fileAccessService is ", base64data);
    return {
      success: true,
      platform: "web",
      fileName: extractedFileName,
      contentType,
      base64data, // ✅ Now guaranteed to be ready
    };
    // return { success: true, platform: 'web', fileName: extractedFileName };
  } catch (error) {
    throw error;
  }
};

function arrayBufferToBase64(buffer: any, mimeType = "application/pdf") {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const chunkSize = 8192; // prevents call stack overflow

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk: any = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }

  const base64String = window.btoa(binary); // ✅ FIX: no encodeURIComponent
  const base64DataString = getBase64UriFromBuffer(base64String, mimeType);
  
  return base64DataString;
}

export const downloadFromBase64Web = (base64Data: string, fileName: string) => {
  // const linkSource = `data:${getFileType(file)};base64,${base64String}`;
  const downloadLink = document?.createElement('a')
    ? document?.createElement('a')
    : { href: '', download: '', click: () => true };
  downloadLink.href = base64Data;
  downloadLink.download = fileName;
  downloadLink.click();
  return null;
}
